@if (obser$ | async; as obser) {
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
    <form-wrapper>
      @if (dismemberment) {
        <ng-container formGroupName="parameters">
          <div class="row">
            <div class="col-md-6">
              <pr-input-radio
                formControlName="investmentDurationViager"
                columns="3"
                [toggle]="true"
                [isDefault]="false"
                label="Souscrivez-vous en viager ?"
              >
              </pr-input-radio>
            </div>
          </div>
        </ng-container>
      }
      <ng-container formArrayName="scpis">
        @for (scpi of scpis.controls; track scpi; let index = $index) {
          <ng-container [formGroup]="scpi">
            <ng-container formGroupName="parameters">
              <div class="card">
                <div class="card-front">
                  <div class="card-content">
                    <h3 style="margin-bottom: 1rem">
                      {{ scpi.get('productName').value }}
                    </h3>
                    @if (dismemberment) {
                      <!-- En viager la durée est imposée (99 ans) : pas de saisie. -->
                      @if (!investmentDurationViager) {
                        <div class="row">
                          <div class="col-md-6">
                            <pr-input-column
                              label="Durée de démembrement"
                              [derrors]="derrors"
                              [isDefault]="false"
                              [suffix]="'ans'"
                            >
                              <!-- round number -->
                              <input
                                notdot
                                formControlName="dismembermentDuration"
                                type="number"
                              />
                            </pr-input-column>
                          </div>
                        </div>
                      }
                      <div class="row">
                        <div class="col-md-6">
                          <pr-input-column
                            label="Clé de démembrement"
                            [derrors]="derrors"
                            [isDefault]="false"
                            [suffix]="'%'"
                          >
                            <!-- min 0 max 100 -->
                            <input
                              eaNumericInput
                              formControlName="dismembermentDistributionKey"
                              type="number"
                            />
                          </pr-input-column>
                        </div>
                      </div>
                    }
                    <div class="row">
                      <div class="col-md-6">
                        <pr-input-radio
                          formControlName="type"
                          [derrors]="derrors"
                          direction="column"
                          [isDefault]="false"
                          [options]="[
                            {
                              value: 'A',
                              label: 'Le montant à investir',
                              suffix: { title: 'A' },
                            },
                            {
                              value: 'B',
                              label: 'Le nombre de parts',
                              suffix: { title: 'B' },
                            },
                          ]"
                          label="Vous souhaitez saisir :"
                        >
                        </pr-input-radio>
                      </div>
                      @if (scpi.get('parameters')?.get('type')?.value === 'A') {
                        <div class="col-md-6">
                          <pr-input-column
                            label="Montant souhaité"
                            [derrors]="derrors"
                            [isDefault]="false"
                          >
                            <input formControlName="amount" type="text" />
                          </pr-input-column>
                        </div>
                      }
                      @if (scpi.get('parameters')?.get('type')?.value === 'B') {
                        <div class="col-md-6">
                          <pr-input-column
                            label="Nombre de parts"
                            [derrors]="derrors"
                            [isDefault]="false"
                          >
                            <input
                              eaNumericInput
                              formControlName="scpiNbPart"
                              type="number"
                            />
                          </pr-input-column>
                        </div>
                      }
                    </div>
                    @if (
                      !dismemberment ||
                      scpi?.get('parameters')?.get('scpiDismembermentPartPrice')
                        ?.value
                    ) {
                      <div class="row" style="margin: 0 32px 0 0">
                        @if (!dismemberment) {
                          <div class="col-md-6">
                            <div class="scpiValue">
                              {{ scpi.get('productName').value }} :
                              {{
                                dismemberment
                                  ? scpi
                                      ?.get('parameters')
                                      ?.get('scpiDismembermentPartPrice')?.value
                                  : scpi
                                      ?.get('parameters')
                                      ?.get('scpiPartPrice')?.value
                              }}
                              €/Part
                            </div>
                          </div>
                        }
                        @if (dismemberment) {
                          <div class="col-md-6">
                            <div class="row" style="margin: 0 32px 0 0">
                              <div class="scpiValue">
                                {{
                                  scpiOwnershipType === 'USUFRUIT'
                                    ? 'Usufruit'
                                    : 'Nue propriété'
                                }}
                                :
                                {{
                                  scpi
                                    ?.get('parameters')
                                    ?.get('scpiDismembermentPartPrice')?.value
                                }}
                                €/Part
                              </div>
                            </div>
                            <div class="row" style="margin: 0 32px 0 0">
                              <div class="scpiValue">
                                Pleine propriété :
                                {{
                                  scpi?.get('parameters')?.get('scpiPartPrice')
                                    ?.value
                                }}
                                €/Part
                              </div>
                            </div>
                          </div>
                        }
                        @if (
                          scpi?.get('parameters')?.get('type')?.value === 'B'
                        ) {
                          <div class="col-md-6">
                            <div class="scpiInvest">
                              Soit
                              {{
                                totalInvestment(
                                  scpi?.get('parameters')?.get('scpiPartPrice')
                                    ?.value,
                                  scpi
                                    ?.get('parameters')
                                    ?.get('scpiDismembermentPartPrice')?.value,
                                  scpi?.get('parameters')?.get('scpiNbPart')
                                    ?.value,
                                  dismemberment
                                )
                              }}€ d’investissement
                            </div>
                          </div>
                        }
                      </div>
                    }
                    @if (scpi?.get('parameters')?.get('type')?.value === 'A') {
                      <div class="row" style="margin: 32px 32px 0 0">
                        <div class="col-md-12 info scpi-part-multiple-warning">
                          <pr-color-panel [display]="'warning'">
                            <pr-panel-body clazz="pam">
                              <pr-label
                                [name]="'info'"
                                [width]="18"
                                [height]="18"
                              >
                                <div class="row" style="font-size: 14px">
                                  <div class="col-md-12">
                                    <p
                                      style="color: var(--font-color)"
                                      class="text-p"
                                    >
                                      <b style="color: var(--font-color)"
                                        >Le Montant d’investissement doit être
                                        un multiple de
                                        {{
                                          dismemberment
                                            ? scpi
                                                ?.get('parameters')
                                                ?.get(
                                                  'scpiDismembermentPartPrice'
                                                )?.value
                                            : scpi
                                                ?.get('parameters')
                                                ?.get('scpiPartPrice')?.value
                                        }}€ </b
                                      >(prix de la parts
                                      {{ scpi.get('productName').value }})
                                      Veuillez donc choisir le montant entre le
                                      montant légèrement inferieur ou le montant
                                      légèrement superieur
                                    </p>
                                  </div>
                                  <div
                                    class="col-md-12"
                                    style="
                                      display: flex;
                                      justify-content: center;
                                      color: var(--font-color);
                                    "
                                  >
                                    @if (
                                      formatSCPIPartsSuperior(
                                        scpi
                                          ?.get('parameters')
                                          ?.get('scpiPartDivisible')?.value,
                                        scpi?.get('parameters')?.get('amount')
                                          ?.value,
                                        dismemberment,
                                        scpi
                                          ?.get('parameters')
                                          ?.get('scpiPartPrice')?.value,
                                        scpi
                                          ?.get('parameters')
                                          ?.get('scpiDismembermentPartPrice')
                                          ?.value
                                      )
                                    ) {
                                      <pr-input-radio
                                        style="
                                          color: var(--font-color);
                                          width: 100%;
                                        "
                                        formControlName="slightlyAmount"
                                        [derrors]="derrors"
                                        direction="column"
                                        [isDefault]="false"
                                        [options]="[
                                          {
                                            value: formatSCPIPartsLower(
                                              scpi
                                                ?.get('parameters')
                                                ?.get('scpiPartDivisible')
                                                ?.value,
                                              scpi
                                                ?.get('parameters')
                                                ?.get('amount')?.value,
                                              dismemberment,
                                              scpi
                                                ?.get('parameters')
                                                ?.get('scpiPartPrice')?.value,
                                              scpi
                                                ?.get('parameters')
                                                ?.get(
                                                  'scpiDismembermentPartPrice'
                                                )?.value
                                            ),
                                            label:
                                              formatSCPIPriceWithPartsLower(
                                                scpi
                                                  ?.get('parameters')
                                                  ?.get('scpiPartDivisible')
                                                  ?.value,
                                                scpi
                                                  ?.get('parameters')
                                                  ?.get('amount')?.value,
                                                dismemberment,
                                                scpi
                                                  ?.get('parameters')
                                                  ?.get('scpiPartPrice')?.value,
                                                scpi
                                                  ?.get('parameters')
                                                  ?.get(
                                                    'scpiDismembermentPartPrice'
                                                  )?.value
                                              ),
                                          },
                                          {
                                            value: formatSCPIPartsSuperior(
                                              scpi
                                                ?.get('parameters')
                                                ?.get('scpiPartDivisible')
                                                ?.value,
                                              scpi
                                                ?.get('parameters')
                                                ?.get('amount')?.value,
                                              dismemberment,
                                              scpi
                                                ?.get('parameters')
                                                ?.get('scpiPartPrice')?.value,
                                              scpi
                                                ?.get('parameters')
                                                ?.get(
                                                  'scpiDismembermentPartPrice'
                                                )?.value
                                            ),
                                            label:
                                              formatSCPIPriceWithPartsSuperior(
                                                scpi
                                                  ?.get('parameters')
                                                  ?.get('scpiPartDivisible')
                                                  ?.value,
                                                scpi
                                                  ?.get('parameters')
                                                  ?.get('amount')?.value,
                                                dismemberment,
                                                scpi
                                                  ?.get('parameters')
                                                  ?.get('scpiPartPrice')?.value,
                                                scpi
                                                  ?.get('parameters')
                                                  ?.get(
                                                    'scpiDismembermentPartPrice'
                                                  )?.value
                                              ),
                                          },
                                        ]"
                                        label=""
                                      >
                                      </pr-input-radio>
                                    }
                                  </div>
                                </div>
                              </pr-label>
                            </pr-panel-body>
                          </pr-color-panel>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        }
      </ng-container>
    </form-wrapper>
    <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
  </form>
} @else {
  <pr-loader></pr-loader>
}
